import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapLocation from '../enums/MapLocation';

type logTrailConditionsCTAViewedParams = {
  map_location: MapLocation;
};

/**
 * User views at least one trail conditions overlay CTA
 * @param params - Attributes to log with the amplitude event
 * @param params.map_location - The location of the map where the user saw the CTAs
 */
const logTrailConditionsCTAViewed = ({ map_location }: logTrailConditionsCTAViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail conditions cta viewed', { 'map location': map_location }, callback);
};

export default logTrailConditionsCTAViewed;
